import React, { useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import renderIf from 'render-if';
import { InplaceField } from '@aha-app/react-in-place';
import UserTriggerItems from '../../SelectroV2/Templates/Users/UserTriggerItems';
import UserAvatar from '../../SelectroV2/Templates/Users/components/UserAvatar';

const Assignee = ({
  className,
  currentUser,
  editable,
  selectroProps,
  defaultValue,
  ...props
}) => {
  const inplaceRef = useRef(null);
  /**
   * currentValue is only used to keep the custom trigger template up to date.
   * Is not used by selectro internally. It removes the 2-3 seconds it takes
   * the server to return the new value, making the UI feel instant.
   */
  const [currentValue, setCurrentValue] = useState(props.value);

  useEffect(() => {
    setCurrentValue(props.value);
  }, [props.value]);

  if (!editable) {
    return (
      <div className='attribute__value-container'>
        <div className='attribute__value-input'>
          <div className='attribute__plain-text-value tw-flex tw-items-center tw-gap-1'>
            <UserAvatar
              avatar={currentValue.avatar}
              text={currentValue.text}
              initials={currentValue.initials}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='attribute__value-container'>
      <div
        className='attribute__value-input react-in-place-wrapper--block'
        style={{ display: 'flex' }}
      >
        <InplaceField
          {...props}
          {...selectroProps}
          class={className}
          ref={inplaceRef}
          tabIndex='1'
          type='selectro'
          onValueChange={value => setCurrentValue(value || defaultValue)}
          selectroType='single'
          searchFields={['text', 'email']}
          templates={internalProps => ({
            trigger: ({ items }) => (
              <div
                className={`${internalProps.class} ${classnames({
                  'react-in-place__placeholder': true,
                  'react-in-place--empty': !items.length,
                  'react-in-place--active':
                    internalProps.showInput || internalProps.focusing,
                })}`}
                tabIndex={1}
                data-testid='demo-test'
              >
                <div className='react-in-place__content'>
                  <UserTriggerItems items={[currentValue]} />
                </div>
              </div>
            ),
            itemContent: 'Selectro_v2.itemContent.showUserEmailWhenSearching',
            ...props.templates,
          })}
        />
      </div>
      {renderIf(!currentValue || currentUser.value !== currentValue.value)(
        () => (
          <div className='attribute__value-controls'>
            <button
              className='btn btn-link attribute__control'
              onClick={() => {
                // @ts-ignore
                inplaceRef.current?.setValue(currentUser);
              }}
              data-testid='assignee-assign-to-me'
            >
              Assign to me
            </button>
          </div>
        )
      )}
    </div>
  );
};

export default Assignee;
